import React, { createContext, useContext, useState } from "react";
import { ILogic } from "../IRequestModel/ILogicModel";

export const SPActionContext = createContext<
    [ILogic[], React.Dispatch<React.SetStateAction<ILogic[]>>]

>([[], () => { }]);

export const useSPActionContext = () => useContext(SPActionContext);

export const SPActionContextProvider: React.FC<
React.PropsWithChildren<{}>> = ({ children }) => {
const [SPLogics, setSPLogics] = useState<ILogic[]>([]);

const defaultSPActionContext: [
ILogic[],
React.Dispatch<React.SetStateAction<ILogic[]>>
] = [SPLogics, setSPLogics];

return (
<SPActionContext.Provider value={defaultSPActionContext}>
{children}
</SPActionContext.Provider>
);
};
